import {
  browserProfilingIntegration,
  browserTracingIntegration,
  captureConsoleIntegration,
  consoleLoggingIntegration,
  extraErrorDataIntegration,
  httpClientIntegration,
  init,
} from "@sentry/react"
import { isClientError } from "./clientError"
import { getEnv } from "@/utils"

export default () => {
  init({
    dsn: getEnv("SENTRY_DSN"),
    environment: getEnv("ENVIRONMENT"),
    release: getEnv("RELEASE"),
    enableLogs: true,
    attachStacktrace: true,
    normalizeDepth: 10,
    integrations: [
      consoleLoggingIntegration({
        levels: ["info", "warn", "error", "log", "assert"],
      }),
      captureConsoleIntegration({ levels: ["error", "assert"] }),
      extraErrorDataIntegration(),
      httpClientIntegration(),
      browserTracingIntegration(),
      browserProfilingIntegration(),
      // TODO: fix
      //replayIntegration(),
    ],
    ignoreErrors: [],
    // 4xx client errors are operational, not bugs — drop the issue but keep the
    // Sentry log (logs run through the separate beforeSendLog pipeline).
    beforeSend: (event, hint) => {
      // captureConsoleIntegration stashes the raw console.error args here when the
      // logged value isn't an Error — that's where an RTK Query { status } lands.
      const consoleArgs: unknown = event.extra?.arguments

      const candidates: unknown[] = [
        hint.originalException,
        event.contexts?.response,
        consoleArgs,
      ]

      return isClientError(candidates) ? null : event
    },
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/promptjuggler\.(com|wip)/],
    profileSessionSampleRate: 0.1,
    profileLifecycle: "trace",
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  })
}
